import { useCallback, useContext } from 'react';

import type { RequestResize } from '@sorare/wallet-shared';
import { MessagingContext } from '@sorare/wallet-shared';

const useRequestPlaceholderResize = () => {
  const { sendRequest } = useContext(MessagingContext)!;

  return useCallback(
    ({ height, width }: DOMRectReadOnly) => {
      if (height && width) {
        return sendRequest<RequestResize>('requestPlaceholderResize', {
          height,
          width,
          swallowIfNoHandler: true,
        });
      }
      return {};
    },
    [sendRequest]
  );
};

export default useRequestPlaceholderResize;
